import { Radio } from "lucide-react";

// Bottom live status ticker (continuous marquee).
export default function LiveTicker({ items }) {
  const row = items.filter(Boolean);
  return (
    <div data-testid="live-storm-ticker" className="relative z-[720] h-9 shrink-0 bg-[#010818] border-t border-cyan/30 flex items-center overflow-hidden">
      <div className="h-full px-3 flex items-center gap-2 bg-cyan text-[#012173] font-heading font-bold uppercase tracking-widest text-xs shrink-0 z-10">
        <Radio className="w-3.5 h-3.5 animate-pulse" /> Live
      </div>
      <div className="flex-1 overflow-hidden ticker-mask">
        <div className="ticker-track flex whitespace-nowrap">
          {[0, 1].map((k) => (
            <div key={k} className="flex shrink-0" aria-hidden={k === 1}>
              {row.map((it, i) => (
                <span key={i} className="font-mono-t text-[11px] text-slate-200 px-5 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full" style={{ background: it.color || "#FCC109" }} />
                  <span className="text-slate-400 uppercase tracking-wider">{it.label}</span>
                  <span className="font-semibold" style={{ color: it.color || "#e2e8f0" }}>{it.value}</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
